export enum RelationReportMethod {
  INCIDENT = 'INCIDENT',

  SERVICEREQUEST = 'SERVICEREQUEST',

  CHANGE = 'CHANGE',

  COMPLAINT = 'COMPLAINT',
}
